
<app-loader *ngIf="showLoader" [loaderType]="loaderType" [loaderMsg]="showLoader"></app-loader>

<h5>Attention!</h5>
<section class="error-wrapper"
    *ngIf="custAlertsService?.alertListDataMap[this.rootScope.activeCustTab.customerSessionId]?.isAPIError">
    <section class="error-wrapper">
        <f-alert variant="error">
            <p>{{alertListErrMsg}} <a href="javascript:void('0')" (click)="getAllAlerts()">
                    Try again</a> </p>
        </f-alert>
    </section>
</section>
<p class="no-result hide1"
    *ngIf="!custAlertsService?.alertListDataMap[this.rootScope.activeCustTab.customerSessionId]?.isAPIError && alertList?.length==0">
    There are no attention items.
</p>

<f-accordion class="manual-alert">
    <div id="ng-container" *ngFor="let alert of alertList; trackBy: trackItem">
        <div id="mat-expansion-panel">
    
    <f-accordion-item [ngClass]="alert?.isReviwed ? 'reviewed' : ''" [text]="alert.headline + (alert.isReviwed ? ' (Reviewed)' : '')">
        
        <div class="panel-body mat-expansion-panel-body">
            <div class="body-header-CTA">
                <button class="more-info"><span class="hide">More info</span></button>
                <button *ngIf="!enableAlertEdit(alert)" [disabled]='true' class="edit-alert"
                    (click)="editAlert(alert)">
                    Edit <i class="fa-regular fa-pen-to-square"></i>
                </button>

                <button *ngIf="enableAlertEdit(alert)" (click)="editAlert(alert)">
                    Edit <i class="fa-regular fa-pen-to-square"></i>
                </button>


            </div>

            <section class="error-wrapper" *ngIf="alert?.displaySaveAlertErrMsg">
                <f-alert variant="error">{{ saveAlertFailMsg}}</f-alert>
            </section>
            <div class="alert-fields form">
                <div class="alert-field left">
                    <span class="form-label">Author</span>
                    <span class="form-value"> {{alert.authorName}}</span>
                </div>
                <div class="alert-field center">
                    <span class="form-label">Creation date</span>
                    <span class="form-value">{{alert.created}}</span>
                </div>
                <div class="alert-field right">
                    <span class="form-label">Expiration date</span>
                    <span class="form-value">{{alert.expired}}</span>
                </div>
                <div class="alert-field left alert-title">
                    <span class="form-label">Title</span>
                    <span class="form-value" *ngIf="!alert.enableAlertEdit">{{alert.headline}}</span>
                    <mat-form-field *ngIf="alert.enableAlertEdit" appearance="fill" class="component-box">
                        <input matInput [(ngModel)]="alert.editTitle" id="headline" placeholder="headline" />
                    </mat-form-field>
                </div>

                <div class="alert-field left alert-description">
                    <span class="form-label">Details</span>
                    <span class="form-value" *ngIf="!alert.enableAlertEdit">
                        {{alert.detail}}
                    </span>

                    <!-- <mat-form-field *ngIf="alert.enableAlertEdit" appearance="fill"
                        class="component-box description-input">
                        <textarea [(ngModel)]="alert.editDesc" matInput></textarea>
                    </mat-form-field> -->


                    <div *ngIf="alert.enableAlertEdit" class="alert-description-textarea">
                        <f-textarea [value]="alert.editDesc"
                        [(ngModel)]="alert.editDesc">
                        </f-textarea>
                    </div>
                   
                </div>
            </div>


            <div class="edit-alert-CTA" *ngIf="alert.enableAlertEdit">
                <f-button class="btn-alert create" text="Cancel" title="Cancel" type="button"
                    (buttonClicked)="onEditCancelClick(alert)" variant="action">
                </f-button>

                <f-button text="Save" title="save" type="button" variant="progressive"
                    (buttonClicked)="onEditSaveClick(alert)">
                </f-button>
            </div>

            <div class="body-fotter-CTA">
                <button mat-button1 color="primary" class="btn-alert"
                    (click)="reviewUnreview(alert.runtimeAlertId)">
                    <span *ngIf="!alert?.isReviwed"> <i class="fa-regular fa-circle-check"></i>
                        <span>Mark as reviewed</span></span>
                    <span *ngIf="alert?.isReviwed"> <i class="fa-solid fa-circle-check"></i>
                        <span>Mark as unreviewed</span></span>
                </button>
                    
                <button mat-button1 *ngIf="enableAlertEdit(alert) && !alert.disableDelete"  color="primary" class="btn-delete" (click)="deleteAlert(alert)">
                    <span>Delete</span>
                    <i class="fa-light fa-trash-can"></i>
                </button>

                <button mat-button1 *ngIf="enableAlertEdit(alert) && alert.disableDelete" [disabled]='true' color="primary" class="btn-delete" (click)="deleteAlert(alert)">
                    <span>Delete</span>
                    <i class="fa-light fa-trash-can"></i>
                </button> 
                            </div>

            <div class="confirm-dialog" *ngIf="alert?.showDeleteAlert">
                <p>Are you sure you want to delete this alert?</p>

                <button mat-button1 color="primary" class="btn-confirm-delete" (click)="performDelete(alert)">
                    <span>Delete</span>
                </button>

                <button mat-button1 color="primary" class="btn-cancel" (click)="closeDeleteAlert(alert)">
                    <span>Cancel</span>
                </button>
            </div>
        </div>
    </f-accordion-item>
    </div>
</div>
 </f-accordion>



<!-- <mat-accordion class="manual-alert"> 
    <ng-container *ngFor="let alert of alertList; trackBy: trackItem">
        <mat-expansion-panel [ngClass]="alert?.isReviwed ? 'reviewed' : ''" [expanded]="alert?.isOpen"
            (opened)="openAccordian(alert)" (closed)="closeAccordian(alert)">
            <mat-expansion-panel-header [class.linkDisabled]='disableAlert'>

                <div class="panel-title" (click)="$event.stopPropagation();">
                    <h6>
                        {{alert.headline}}
                    </h6>
                    <span class="deadline-date red" *ngIf="alert?.deadlineDate">Deadline:
                        {{alert.deadlineDate}}</span>
                </div>
                <span class="reviewflag" *ngIf="alert?.isReviwed">Reviewed</span>
            </mat-expansion-panel-header>
            <div class="panel-body">
                <div class="body-header-CTA">
                    <button class="more-info"><span class="hide">More info</span></button>
                    <button *ngIf="!enableAlertEdit(alert)" [disabled]='true' class="edit-alert"
                        (click)="editAlert(alert)">
                        Edit <i class="fa-regular fa-pen-to-square"></i>
                    </button>

                    <button *ngIf="enableAlertEdit(alert)" (click)="editAlert(alert)">
                        Edit <i class="fa-regular fa-pen-to-square"></i>
                    </button>


                </div>

                <section class="error-wrapper" *ngIf="alert?.displaySaveAlertErrMsg">
                    <f-alert variant="error">{{ saveAlertFailMsg}}</f-alert>
                </section>
                <div class="alert-fields form">
                    <div class="alert-field left">
                        <span class="form-label">Author</span>
                        <span class="form-value"> {{alert.authorName}}</span>
                    </div>
                    <div class="alert-field center">
                        <span class="form-label">Creation date</span>
                        <span class="form-value">{{alert.created}}</span>
                    </div>
                    <div class="alert-field right">
                        <span class="form-label">Expiration date</span>
                        <span class="form-value">{{alert.expired}}</span>
                    </div>
                    <div class="alert-field left alert-title">
                        <span class="form-label">Title</span>
                        <span class="form-value" *ngIf="!alert.enableAlertEdit">{{alert.headline}}</span>
                        <mat-form-field *ngIf="alert.enableAlertEdit" appearance="fill" class="component-box">
                            <input matInput [(ngModel)]="alert.editTitle" id="headline" placeholder="headline" />
                        </mat-form-field>
                    </div>

                    <div class="alert-field left alert-description">
                        <span class="form-label">Details</span>
                        <span class="form-value" *ngIf="!alert.enableAlertEdit">
                            {{alert.detail}}
                        </span>


                        <div *ngIf="alert.enableAlertEdit" class="alert-description-textarea">
                            <f-textarea [value]="alert.editDesc"
                            [(ngModel)]="alert.editDesc">
                            </f-textarea>
                        </div>
                       
                    </div>
                </div>


                <div class="edit-alert-CTA" *ngIf="alert.enableAlertEdit">
                    <f-button class="btn-alert create" text="Cancel" title="Cancel" type="button"
                        (buttonClicked)="onEditCancelClick(alert)" variant="action">
                    </f-button>

                    <f-button text="Save" title="save" type="button" variant="progressive"
                        (buttonClicked)="onEditSaveClick(alert)">
                    </f-button>
                </div>

                <div class="body-fotter-CTA">
                    <button mat-button1 color="primary" class="btn-alert"
                        (click)="reviewUnreview(alert.runtimeAlertId)">
                        <span *ngIf="!alert?.isReviwed"> <i class="fa-regular fa-circle-check"></i>
                            <span>Mark as reviewed</span></span>
                        <span *ngIf="alert?.isReviwed"> <i class="fa-solid fa-circle-check"></i>
                            <span>Mark as unreviewed</span></span>
                    </button>
                        
                    <button mat-button1 *ngIf="enableAlertEdit(alert) && !alert.disableDelete"  color="primary" class="btn-delete" (click)="deleteAlert(alert)">
                        <span>Delete</span>
                        <i class="fa-light fa-trash-can"></i>
                    </button>

                    <button mat-button1 *ngIf="enableAlertEdit(alert) && alert.disableDelete" [disabled]='true' color="primary" class="btn-delete" (click)="deleteAlert(alert)">
                        <span>Delete</span>
                        <i class="fa-light fa-trash-can"></i>
                    </button> 
                                </div>

                <div class="confirm-dialog" *ngIf="alert?.showDeleteAlert">
                    <p>Are you sure you want to delete this alert?</p>

                    <button mat-button1 color="primary" class="btn-confirm-delete" (click)="performDelete(alert)">
                        <span>Delete</span>
                    </button>

                    <button mat-button1 color="primary" class="btn-cancel" (click)="closeDeleteAlert(alert)">
                        <span>Cancel</span>
                    </button>
                </div>
            </div>
        </mat-expansion-panel>
    </ng-container>
</mat-accordion> -->

<!-- locked attention alert msg here-->
<div class="locked-alerts" *ngIf="showLockedAlertMsg">
    <p><i class="fa-light fa-lock"></i> Secure the call to view locked attention items <span
            class="alert-count">( {{noOfLockedAlerts}} )</span> </p>
</div>

<!-- Below button used for create alert -->
<div class="create-alert-row">

    <f-button [iconConfig]="iconConfig" class="btn-alert create" text="Create an alert" title="Create an alert"
        type="button" variant="progressive" (click)="openCreateAlert()">
    </f-button>

    <button mat-button color="primary" title="View expired" class="btn-alert Expired" (click)="viewExpiredAlerts()" >
        <i class="fa-solid fa-eye"></i>
        <span>View expired </span>
      </button>
</div>
